import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) navigate('/admin/lists');
  }, [isAuthenticated, navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
      const res = await axios.post(`${baseUrl}/api/auth/login`, formData);
      const { token, username, role, message: successMsg } = res.data;

      if (!token) {
        setMessage('Login failed — token not received.');
        return;
      }

      login({ token, username, role });
      setMessage(successMsg || 'Login successful');
      navigate('/admin/lists');
    } catch (err) {
      setMessage(err?.response?.data?.message || 'Invalid credentials');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-brand">
            <span className="login-logo">IGF</span>
            <h1>Rankings Tool</h1>
            <p className="text-muted">Athlete qualifiers management</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email or username
              </label>
              <input
                id="email"
                name="email"
                type="text"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
                autoComplete="username"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className="input-group">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                >
                  <i className={`bi bi-eye${showPassword ? '-slash' : ''}`} />
                </button>
              </div>
            </div>
            {message && (
              <div
                className={`alert ${message.toLowerCase().includes('success') ? 'alert-success' : 'alert-danger'} py-2`}
                role="alert"
              >
                {message}
              </div>
            )}
            <button
              type="submit"
              className="btn btn-success w-100 login-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
